module.exports = __webpack_public_path__ + "static/media/qrcode-icon.1aa9fb01.svg";